import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useActiveClinicaId } from "@/hooks/useActiveClinicaId";
import { hasAnyPermission, permissionsForActiveClinic } from "@/lib/permissions";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

type PermissionRouteProps = {
  children: ReactNode;
  anyOf: string[];
};

export function PermissionRoute({ children, anyOf }: PermissionRouteProps) {
  const { user } = useAuth();
  const role = user?.role || user?.perfil;
  const selectedClinicaId = useActiveClinicaId();
  const activeClinicaId = selectedClinicaId || user?.clinica_id;
  const effectivePermissions = permissionsForActiveClinic(user?.permissoes_extra || [], user?.permissoes_por_clinica, activeClinicaId);

  if (hasAnyPermission(role, anyOf, effectivePermissions)) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-background p-6">
      <Card className="mx-auto mt-12 max-w-xl">
        <CardContent className="space-y-4 p-6 text-center">
          <ShieldAlert className="mx-auto h-10 w-10 text-muted-foreground" />
          <div>
            <h1 className="text-xl font-semibold">Acesso não liberado</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Seu perfil não tem permissão para abrir esta área. Fale com o administrador da clínica se precisar desse acesso.
            </p>
          </div>
          <Button asChild>
            <Link to="/dashboard">Voltar ao início</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
